import React, { useEffect, useRef, useState } from "react"
import {
  Box,
  Button,
  Divider,
  FormControl,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Tooltip,
  Collapse,
} from "@mui/material"
import { FaChevronDown, FaChevronLeft, FaChevronUp } from "react-icons/fa6"
import * as Style from "./style"
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom"
import {
  overViewApi,
  useActivePostQuery,
  useGenOtpMutation,
  useVerifyOtpMutation,
} from "../../features/OverViewAuth/overViewApi"
import {
  Timeline,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
  TimelineConnector,
  TimelineDot,
  TimelineContent,
} from "@mui/lab"

import moment from "moment"
import CircularIndeterminate from "../Loading/Loading"
import { toast } from "react-toastify"
interface DateProps {
  dateString: string
}

const FormatDate = ({ dateString }: DateProps) => {
  const utcDate = moment.utc(dateString).local()
  return <>{utcDate.format("dddd")}</>
}

const FormatTime = ({ dateString }: DateProps) => {
  const utcDate = moment.utc(dateString).local()
  return <div>{utcDate.format("D-MMMM")}</div>
}

const FormatChangeTime = ({ dateString }: DateProps) => {
  const utcDate = moment.utc(dateString).local()
  return <div> {utcDate.format("h:mm A")}</div>
}

const FormatDateMonthDay = ({ dateString }: DateProps) => {
  const utcDate = moment.utc(dateString).local()
  return <div>{utcDate.format("DD MMM, dddd")}</div>
}
import CenteredSpinner from "../common/CenteredSpinner"
import RatingStars from "../common/rating"
import dummyImage from "../../images/dummy-icon.png"
import chatimage from "../../images/chatimage.png"
import GenRateotpCustomer, {
  PayPriceForService,
  ServiceStart,
} from "./genrateOtpCus"
import dummy from "../../images/dummy-icon.png"
import StopService, {
  ColumnGroupingTable,
} from "./StopServiceModal/StopService"
import { useAppSelector } from "../../app/hooks"
import { api, useLogoutCustomerMutation } from "../../features/Auth/authApi"
import { useAppDispatch } from "../../app/store"
import { useCreateTicketMutation } from "../../features/ChatAuth/chatApi"
import { _paymentDetails } from "../../features/Auth/authSlice"
import { paymenterFace } from "../Booking/postInterFace"
import ExtraDetailsDisplay from "../ExtraDetailsSeeker/ExtraDetailsDisplay"
const ViewProfile = () => {
  const { id } = useParams()
  const dispatch = useAppDispatch()
  const urlSearchParams = new URLSearchParams(window.location.search)
  const userId = urlSearchParams.get("userId")
  const userLoginId = useAppSelector(
    (state: any) => state.auth?.userInfo?.user?._id,
  )
  const [logoutProvider, { data: logoutData }] = useLogoutCustomerMutation()
  const [
    otpGenrate,
    { data: otpData, error: otpError, isLoading: otpLoading },
  ] = useGenOtpMutation()
  const {
    data: activePost,
    isFetching,
    isLoading,

    error,
  } = useActivePostQuery({ postId: id })

  const [
    submitOtpProvider,
    { data: submitotpData, error: submitotpError, isLoading: submitotpLoading },
  ] = useVerifyOtpMutation()

  const navigate = useNavigate()
  const [open, setOpen] = React.useState(false)
  const [fillOtp, setFillOtp] = useState<string>("")
  const otpRef = useRef<HTMLInputElement[]>([])
  const [otp, setOtp] = useState(Array(6).fill(""))
  const [reasonlist, setReasonList] = React.useState(false)
  const socketId = useAppSelector((state) => state.auth)
  const [showExtraDetails, setShowExtraDetails] = useState(false)
  // timeLine Show more Button
  const [showFullTimeline, setShowFullTimeline] = useState(false)
  const handleToggleTimeline = () => {
    setShowFullTimeline(!showFullTimeline)
  }
  // end
  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const getAction = (jobflow?: string) => {
    if (!jobflow) return "START"
    const jf = jobflow.toUpperCase()

    // START flows
    if (jf === "JOB_ACTIVE" || jf === "START_OTP_VERIFIED") return "START"

    // END flows - be more specific
    if (jf.includes("STOP") ||
      jf.includes("END") ||
      jf === "PROVIDER_STOP_OTP" ||
      jf === "CUSTOMER_STOP_OTP" ||
      jf === "STOP_SERVICE" ||
      jf === "END_OTP_VERIFIED" ||
      jf === "PROVIDER_STOP_OTP_VERIFIED" ||
      jf === "CUSTOMER_STOP_OTP_VERIFIED") {
      return "END"
    }

    return "START"
  }
  const handleVerifyClickOpen = () => {
    setReasonList(true)
    setOpen(false)
  }

  const reasonListClose = () => {
    setReasonList(false)
  }

  const handleChange = (index: any, event: any) => {
    const newOtp = [...otp]
    const newValue = event.target.value

    if (!otp[index]) {
      newOtp[index] = newValue
    } else {
      newOtp[index] = newValue
    }

    setOtp(newOtp)

    // Focus next input field if available
    if (event.target.nextSibling && newValue !== "") {
      event.target.nextSibling.focus()
    }
  }

  const handleClick = (index: number) => {
    // Focus on the clicked input field
    ; (otpRef as any).current[index].focus()
  }

  const handleKeyDown = (index: any, event: any) => {
    if (event.keyCode === 8 && !otp[index] && otpRef.current[index - 1]) {
      ; (otpRef as any).current[index - 1].focus()
    }
  }

  const handlePaste = (event: React.ClipboardEvent) => {
    event.preventDefault()
    const data = event.clipboardData.getData("text")
    // Only numbers
    const numericData = data.replace(/\D/g, "").slice(0, 6)

    if (numericData.length > 0) {
      const newOtp = numericData.split("").concat(Array(6 - numericData.length).fill(""))
      setOtp(newOtp)
      setFillOtp("")

      // Focus the last filled input or the next one
      const nextIndex = Math.min(numericData.length, 5)
      if (otpRef.current[nextIndex]) {
        otpRef.current[nextIndex].focus()
      }
    }
  }

  const handleOtp = () => {
    const jobAction = getAction(activePost?.data?.activeJobflow) === "START" ? "Start" : "End"
    otpGenrate({ postId: activePost?.data?._id, jobAction })
  }

  // otp genrate funtion

  useEffect(() => {
    if (!otpData) return;

    if (otpData?.message && otpData?.data?.otp) {
      setFillOtp(otpData.data.otp);
      toast.success(otpData.message);
    } else if (otpError) {
      toast.error((otpError as any)?.data?.message);
    }
  }, [otpData, otpError]);

  // end otp function

  const submitOtpFromProvider = async () => {
    const payload = {
      postId: activePost?.data?._id,
      jobAction: "End",
      otp: (fillOtp ? fillOtp.split("") : otp).join(""),
    };

    submitOtpProvider(payload);

    setOtp(Array(6).fill(""));
    setFillOtp("");
  };

  useEffect(() => {
    if (submitotpData?.message) {
      toast.success(submitotpData?.message)
      const postId = activePost?.data?._id

      const startKey = postId ? `otp_${postId}_START` : null
      const endKey = postId ? `otp_${postId}_END` : null

      setFillOtp("")
      if (startKey) localStorage.removeItem(startKey)
      if (endKey) localStorage.removeItem(endKey)
    } else if (submitotpError) {
      toast.error((submitotpError as any)?.data?.message)
    }
  }, [submitotpData, submitotpError])

  useEffect(() => {
    if (activePost?.message) {
      setReasonList(false)
    }
  }, [activePost, error])

  useEffect(() => {
    const payload = {
      chatId: socketId?.socketId,
      notificationId: socketId?.notificationId,
    }
    if (userId == userLoginId || userId == null) {
      console.log("first")
    } else {
      logoutProvider(payload)
      dispatch(api.util.resetApiState()) as any
      dispatch(overViewApi.util.resetApiState()) as any
    }
  }, [userId, userLoginId])

  const [chatView, { data: CharacterData }] = useCreateTicketMutation()

  const handleChatView = async () => {
    const payload = {
      postId: id,
    }

    try {
      const response: any = await chatView(payload)
      if (response?.data?.status === 200) {
        const chatId = response.data?.data?._id
        const adminId = response.data?.data?.adminstration

        if (chatId && adminId) {
          navigate(`/dashboard/help-center?chatId=${chatId}&adminId=${adminId}`)
        } else {
          console.error("Invalid chatId or adminId in response:", response)
        }
      } else {
        console.error("API call was not successful:", response)
      }
    } catch (error) {
      console.error("Error making API call:", error)
    } finally {
    }
  }

  const handlePayment = async () => {
    // Instead of navigating to payment, navigate to review page
    // Get the first service provider's ID (or handle multiple providers)

    if (activePost?.data?.assignedTo && activePost.data.assignedTo.length > 0) {
      // Get the first provider's ID (you can modify this logic if you need multiple reviews)
      const providerId = activePost.data.assignedTo[0]?._id;

      if (providerId) {
        // Navigate to write review page with provider ID
        navigate(`/dashboard/rating-reviews`, {
          state: {
            postDetails: activePost?.data,
            paymentDetails: activePost?.paymentDetail,
            providerDetails: activePost?.data?.assignedTo[0]
          }
        });
      } else {
        toast.error("Provider ID not found");
      }
    } else {
      toast.error("No service provider assigned");
    }
  };

  useEffect(() => {
    if (!activePost?.data) return

    const jobflow = activePost.data.activeJobflow
    const action = getAction(jobflow)

    if (action === "START" && activePost.data.startJobOtp) {
      setFillOtp(activePost.data.startJobOtp)
    }

    if (
      action === "END" &&
      activePost.data.endJobOtp &&
      activePost.data.endOtpGeneratedBy === "currentUser"
    ) {
      setFillOtp(activePost.data.endJobOtp)
    }
  }, [activePost?.data])


  useEffect(() => {
    if (activePost?.message == "Active post completed successfully") {
      navigate("/dashboard")
    }
  }, [activePost])

  console.log("activePost", activePost)

  return (
    <>
      {isLoading ? (
        <CenteredSpinner />
      ) : (
        <Box>
          <Style.Overview>
            <Box className="d-flex justify-content-between align-items-center pb-5">
              <Box className="d-flex align-items-center gap-4">
                <Button className="back-btn mb-0" onClick={() => navigate(-1)}>
                  <FaChevronLeft />
                </Button>
              </Box>
              <Box className="d-flex  align-items-center gap-3">
                <Typography className="status-text mb-0">
                  Status - {" "}
                  <span className="completed fw-bold">
                    {activePost?.data?.status}
                  </span>{" "}
                </Typography>
              </Box>
            </Box>

            <Box>
              {activePost?.data?.activeJobflow === "START_OTP_VERIFIED" ? (
                <ServiceStart
                  isloadingShow={otpLoading}
                  serviceStop={handleClickOpen}
                  blankOtp={setFillOtp}
                  postDetails={activePost?.data}
                />
              ) :
                activePost?.data?.activeJobflow === "END_OTP_VERIFIED" ? (
                  <PayPriceForService
                    handlePayment={handlePayment}
                    postDetailsForPay={activePost}
                  />
                ) :
                  (
                    <GenRateotpCustomer
                      genrateOtp={handleOtp}
                      otpFill={fillOtp}
                      isloadingShow={otpLoading}
                      generateOtp={{ activeJobflow: activePost?.data?.activeJobflow }}
                      handleOtpgeanerate={setFillOtp}
                    />
                  )}
            </Box>

            {/* stop service modal */}
            <StopService
              open={open}
              handleClose={handleClose}
              openReason={handleVerifyClickOpen}
              stopService={activePost?.data}
            />
            {/* ******* */}

            {/* reason modal hanlde */}

            <ColumnGroupingTable
              reasonlist={reasonlist}
              reasonListClose={reasonListClose}
              postId={id as any}
              stopService={activePost?.data}
            />
            {/* ***** */}

            {/* for submit opt then generate by provider */}
            {activePost?.data?.activeJobflow == "PROVIDER_STOP_OTP" && (
              <Box pb={10}>
                <Box className="otp-box text-center">
                  <Box pb={1}>
                    <FormControl className="d-flex justify-content-center gap-3 flex-row">
                      {(fillOtp ? fillOtp.split("") : otp).map((digit, index) => (
                        <input
                          key={index}
                          type="text"
                          maxLength={1}
                          value={digit}
                          onChange={(e) => {
                            if (fillOtp) setFillOtp("")
                            handleChange(index, e)
                          }}
                          onKeyDown={(e) => handleKeyDown(index, e)}
                          onPaste={handlePaste}
                          onClick={() => handleClick(index)}
                          onKeyPress={(event) => {
                            const keyCode = event.keyCode || event.which
                            const keyValue = String.fromCharCode(keyCode)
                            const numericRegex = /^[0-9]+$/

                            if (!numericRegex.test(keyValue)) {
                              event.preventDefault()
                            }
                          }}
                          ref={(ref: any) => (otpRef.current[index] = ref)}
                          style={{
                            maxWidth: "clamp(30px, 3vw, 46px)",
                            height: "clamp(30px, 3vw, 56px)",
                            textAlign: "center",
                            fontFamily: "Montserrat",
                            color: "#F475A4",
                            border: "1px solid #F475A4",
                            borderRadius: "6px",
                            fontSize: "20px",
                          }}
                        />
                      ))}
                    </FormControl>
                  </Box>
                  <Button
                    className="view-profile py-2 text-capitalize"
                    onClick={submitOtpFromProvider}
                  >
                    {submitotpLoading ? <CircularIndeterminate /> : " Submit"}
                  </Button>
                </Box>
              </Box>
            )}

            {/* <PayPriceForService
              handlePayment={handlePayment}
              postDetailsForPay={activePost}
            /> */}

            <Divider className="dark-divider my-5" />
            <Typography
              align="left"
              variant="h2"
              className=" fw-medium font-24"
              mb={1}
            >
              Service Details
            </Typography>
            <Grid container className="mb-1 p-4 service-detail-box-lg gap-4">
              {/* Left Side: Profile Image + Service Name */}
              <Grid item xs={12} lg={3}>
                <Box className="review-card text-center p-2 p-lg-1 d-flex flex-column align-items-center">
                  <Box className="mb-4 profile-img-2 overflow-hidden">
                    <img
                      src={activePost?.data?.service?.image || dummy}
                      className="img-fluid rounded"
                      alt="Service"
                    />
                  </Box>
                  <Typography variant="h6" align="center" className="mb-1">
                    {activePost?.data?.service?.name}
                  </Typography>
                </Box>
              </Grid>

              {/* Right Side: Scrollable Content Box */}
              <Grid item lg={8}>
                <Box
                  sx={{
                    maxHeight: "300px", // Adjust scroll area height here
                    overflowY: "auto",
                    pr: 2,
                  }}
                >
                  {/* Service Required */}
                  <Box
                    sx={{
                      border: "1px solid #D3D3D3",
                      borderRadius: "8px",
                      p: 2,
                      mb: 2,
                      backgroundColor: "#F8F8F8",
                    }}
                  >
                    <Typography variant="body2" fontWeight="bold" mb={1}>
                      Service Required
                    </Typography>
                    <Typography variant="body1">
                      {activePost?.data?.service?.name}
                    </Typography>
                  </Box>

                  {/* Service Date */}
                  {activePost?.data?.from && (
                    <Box
                      sx={{
                        border: "1px solid #D3D3D3",
                        borderRadius: "8px",
                        p: 2,
                        mb: 2,
                        backgroundColor: "#F8F8F8",
                      }}
                    >
                      <Typography variant="body2" fontWeight="bold" mb={1}>
                        Service Date
                      </Typography>
                      <Typography variant="body1">
                        {moment(activePost?.data?.from).format(
                          "DD MMM, dddd , YYYY",
                        )}
                      </Typography>
                    </Box>
                  )}

                  {/* Service Time */}
                  <Box
                    sx={{
                      border: "1px solid #D3D3D3",
                      borderRadius: "8px",
                      p: 2,
                      mb: 2,
                      backgroundColor: "#F8F8F8",
                    }}
                  >
                    <Typography variant="body2" fontWeight="bold" mb={1}>
                      Service Time
                    </Typography>
                    <Box className="d-flex gap-4">
                      <Typography variant="body1">
                        <FormatChangeTime dateString={activePost?.data?.from} />
                      </Typography>
                      <Typography variant="body1">
                        <FormatChangeTime dateString={activePost?.data?.till} />
                      </Typography>
                    </Box>
                  </Box>

                  {/* Language */}
                  <Box
                    sx={{
                      border: "1px solid #D3D3D3",
                      borderRadius: "8px",
                      p: 2,
                      mb: 2,
                      backgroundColor: "#F8F8F8",
                    }}
                  >
                    <Typography variant="body2" fontWeight="bold" mb={1}>
                      Language
                    </Typography>
                    <Typography variant="body1">
                      {activePost?.data?.language?.join(" ")}
                    </Typography>
                  </Box>

                  {/* Location */}
                  <Box
                    sx={{
                      border: "1px solid #D3D3D3",
                      borderRadius: "8px",
                      p: 2,
                      mb: 2,
                      backgroundColor: "#F8F8F8",
                    }}
                  >
                    <Typography variant="body2" fontWeight="bold" mb={1}>
                      Location
                    </Typography>
                    <Typography variant="body1">
                      {activePost?.data?.location}
                    </Typography>
                  </Box>

                  {/* Additional Instructions */}
                  {activePost?.data?.description && (
                    <Box
                      sx={{
                        border: "1px solid #D3D3D3",
                        borderRadius: "8px",
                        p: 2,
                        mb: 2,
                        backgroundColor: "#F8F8F8",
                      }}
                    >
                      <Typography
                        variant="body2"
                        fontWeight="bold"
                        mb={1}
                        style={{ overflowWrap: "anywhere" }}
                      >
                        Additional Instructions
                      </Typography>
                      <Typography variant="body1">
                        {activePost?.data?.description}
                      </Typography>
                    </Box>
                  )}

                  {/* Attachments */}
                  {activePost?.data?.attachments?.length > 0 && (
                    <Box
                      sx={{
                        border: "1px solid #D3D3D3",
                        borderRadius: "8px",
                        p: 2,
                        mb: 2,
                        backgroundColor: "#F8F8F8",
                      }}
                    >
                      <Typography variant="body2" fontWeight="bold" mb={1}>
                        Photos
                      </Typography>
                      <Box className="d-flex flex-wrap gap-2">
                        {activePost?.data?.attachments?.map(
                          (imagePost: any, index: number) => (
                            <img
                              key={index}
                              src={imagePost}
                              className="photo-upload"
                              alt={`attachment-${index}`}
                              style={{
                                width: "100px",
                                height: "auto",
                                borderRadius: "4px",
                                objectFit: "cover",
                                cursor: "pointer",
                              }}
                            />
                          ),
                        )}
                      </Box>
                    </Box>
                  )}
                </Box>
              </Grid>
            </Grid>

            {/* Additional Info Section - Below the service details container */}
            {activePost?.data?.extraDetails && (
              <Box className="px-4 py-4 mt-4 service-detail-box-lg">
                <Button
                  variant="outlined"
                  onClick={() => setShowExtraDetails(!showExtraDetails)}
                  className="text-capitalize d-flex align-items-center gap-2"
                  style={{
                    borderColor: "#F475A4",
                    color: "#F475A4",
                    fontWeight: "600",
                    padding: "8px 16px",
                  }}
                >
                  {showExtraDetails ? (
                    <>
                      <FaChevronUp size={14} className="me-2" />
                      Hide Additional Information
                    </>
                  ) : (
                    <>
                      <FaChevronDown size={14} className="me-2" />
                      Show Additional Information
                    </>
                  )}
                </Button>

                <Collapse in={showExtraDetails}>
                  <Box className="mt-3 p-2 border rounded">
                    <ExtraDetailsDisplay
                      extraDetails={activePost?.data?.extraDetails}
                      serviceType={activePost?.data?.serviceType || activePost?.data?.service?.name}
                    />
                  </Box>
                </Collapse>
              </Box>
            )}
            <Divider className="dark-divider mb-5" />
            <Typography
              align="left"
              variant="h2"
              className=" fw-medium font-24"
              mb={1}
            >
              Service Providers Details
            </Typography>
            <TableContainer
              component={Paper}
              className="dashboard-table-wrapper custom-scrollbar"
            >
              <Table
                style={{
                  minWidth: 650,
                  border: "none",
                  backgroundColor: "#fff",
                  borderRadius: "16px",
                  overflow: "hidden",
                }}
                className="dashboard-table"
                aria-label="simple table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell align="center"></TableCell>
                    <TableCell align="center" className="service-head">
                      Service Provider
                    </TableCell>
                    <TableCell align="center">Email</TableCell>
                    <TableCell align="center">Phone</TableCell>
                    <TableCell align="center">Language</TableCell>
                    <TableCell align="center"></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {activePost?.data?.assignedTo.map((row: any) => (
                    <TableRow
                      key={row?.name}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                    >
                      <TableCell className="user-img">
                        <div className="img-wrapper ms-1">
                          <img
                            src={row?.profilePic || dummyImage}
                            style={{
                              width: "74px",
                              height: "74px",
                              objectFit: "cover",
                            }}
                          />
                        </div>
                      </TableCell>

                      <TableCell component="td" align="center" scope="row">
                        <span className="text flex-column gap-2">
                          {row?.name}
                          <span className="minh-1">
                            <RatingStars rating={row?.rating?.$numberDecimal} />
                          </span>
                        </span>
                      </TableCell>
                      <TableCell align="center">
                        <Tooltip
                          title={row?.email}
                          arrow
                          placement="top"
                          componentsProps={{
                            tooltip: {
                              sx: {
                                backgroundColor: "#000", // black tooltip
                                color: "#fff",
                                fontSize: "0.875rem",
                              },
                            },
                          }}
                        >
                          <span className="email" style={{ cursor: "pointer" }}>
                            {row?.email?.length > 15
                              ? row?.email.slice(0, 15) + "..."
                              : row?.email}
                          </span>
                        </Tooltip>
                      </TableCell>
                      <TableCell align="center">
                        <span className="email">
                          <span>{row?.contactNo}</span>
                        </span>
                      </TableCell>
                      <TableCell align="center">
                        <Box
                          display="flex"
                          flexWrap="wrap"
                          justifyContent="center"
                          gap={1}
                        >
                          {row?.language?.map((lang: string, index: number) => (
                            <Box
                              key={index}
                              sx={{
                                border: "1px solid #fff",
                                backgroundColor: "#f475A4",
                                borderRadius: "10px",
                                padding: "2px 8px",
                                color: "#fff",
                                fontSize: "0.875rem",
                                fontWeight: 500,
                              }}
                            >
                              {lang}
                            </Box>
                          ))}
                        </Box>
                      </TableCell>

                      <TableCell>
                        <span>
                          <Link
                            to={`/dashboard/provider-profile/${row?._id}`}
                            className="view-profile"
                          >
                            View Profile
                          </Link>
                        </span>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <Divider className="dark-divider mb-5" />
            <Box
              className="d-flex mb-5"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography align="left" variant="h2" mb={2}>
                Timeline
              </Typography>
            </Box>

            <Box display="flex" justifyContent="end" marginBottom={4}>
              <Button className="timeline-btn me-4" onClick={handleChatView}>
                Chat
                <img src={chatimage} alt="img" style={{ marginLeft: "10px" }} />
              </Button>
            </Box>

            <Box className="timeline-graph">
              {activePost?.postTimeline
                ?.slice(
                  0,
                  showFullTimeline ? activePost?.postTimeline?.length : 3,
                )
                .map((timeline: any, index: number) => (
                  <Timeline
                    key={timeline._id}
                    position={index % 2 === 0 ? "alternate" : "left"}
                  >
                    <TimelineItem>
                      <TimelineOppositeContent
                        sx={{ m: "10px 0 0" }}
                        align="right"
                        className="timeline-desc"
                        color="text.secondary"
                      >
                        <span className="datetime">
                          <span className="d-flex flex-column">
                            <span className="weekday">
                              <FormatDate dateString={timeline.createdAt} />
                            </span>
                            <span>
                              <FormatChangeTime
                                dateString={timeline.createdAt}
                              />
                            </span>
                            <span>
                              <FormatTime dateString={timeline.createdAt} />
                            </span>
                          </span>
                        </span>

                        <br />
                      </TimelineOppositeContent>
                      <TimelineSeparator>
                        <TimelineConnector />
                        <TimelineDot>
                          <Typography className="timeline-step">
                            0{activePost?.postTimeline?.length - index}
                          </Typography>
                        </TimelineDot>
                        <TimelineConnector />
                      </TimelineSeparator>
                      <TimelineContent sx={{ py: "12px", px: 0.5 }}>
                        <Box className="timeline-content ">
                          <Typography className="timeline-heading">
                            Status - {timeline?.postStatus}{" "}
                          </Typography>
                          <Typography className="timeline-desc"></Typography>
                          <Typography className="timeline-desc">
                            {timeline?.message}{" "}
                          </Typography>
                        </Box>
                      </TimelineContent>
                    </TimelineItem>
                  </Timeline>
                ))}
              <div className="d-flex justify-content-center">
                <Button
                  onClick={handleToggleTimeline}
                  className="view-profile py-2 text-capitalize"
                >
                  {showFullTimeline ? "Show Less" : "Show More"}
                </Button>
              </div>
            </Box>
          </Style.Overview>
        </Box>
      )}
    </>
  )
}
export default ViewProfile
